export let compactViewMixin = {
	initCompactView: (self, classes) => {
		let minimumHeight = 550; // 550px was the chosen number to have compact views
		self.$element = self.$element || $(self.element);
		self.$tplScroller = self.$tplScroller || $('.tpl-scroller');
		classes = classes || [];

		if(self.$tplScroller && self.$tplScroller.length > 0) {
			let applyCompactView = () => {
				self.$element.attr('compact-view', 'true');

				if(classes.length > 0) {
					classes.forEach((classItem) => {
						self.$element.find(classItem).attr('compact-view', true);
					});
				}
			};

			let unapplyCompactView = () => {
				self.$element.removeAttr('compact-view');

				if(classes.length > 0) {
					classes.forEach((classItem) => {
						self.$element.find(classItem).removeAttr('compact-view');
					});
				}
			};

			let isBlockExceedingHeight = () => {
				return self.$tplScroller[0].clientHeight <= minimumHeight ||
					((self.$element.outerHeight() > minimumHeight) && self.$element.outerHeight() > self.$tplScroller[0].clientHeight);
			};

			let toggleCompactViewAttribute = () => {
				if(isBlockExceedingHeight()) {
					applyCompactView();

					// Re-render
					setTimeout(() => {
						if(isBlockExceedingHeight()) {
							applyCompactView();
						}
					}, 500);
				}
				else {
					unapplyCompactView();
				}
			};

			$(window).resize(_.debounce(() => {
				toggleCompactViewAttribute();
			}, 250));

			toggleCompactViewAttribute();
		}
	}
};
